/**
 * @generated SignedSource<<586f44c65e3208379f5f2fdc9915cda3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DateTimeLabel_event$data = {
  readonly allDay: boolean;
  readonly end: {
    readonly date: DateString ;
    readonly time: TimeOfDayString;
    readonly timestamp: Int;
    readonly timezone: TimezoneString;
    readonly utcDate: DateString ;
    readonly utcTime: TimeOfDayString;
  } | null;
  readonly id: string;
  readonly start: {
    readonly date: DateString ;
    readonly time: TimeOfDayString;
    readonly timestamp: Int;
    readonly timezone: TimezoneString;
    readonly utcDate: DateString ;
    readonly utcTime: TimeOfDayString;
  } | null;
  readonly " $fragmentType": "DateTimeLabel_event";
};
export type DateTimeLabel_event$key = {
  readonly " $data"?: DateTimeLabel_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"DateTimeLabel_event">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "time",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timestamp",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "utcTime",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timezone",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DateTimeLabel_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateTime",
      "kind": "LinkedField",
      "name": "start",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DateTime",
      "kind": "LinkedField",
      "name": "end",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allDay",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "d598450bbec65bf56451f6ab36e2ae1b";

export default node;
